import { useFormContext } from 'react-hook-form'; 
const Checkbox = ({children, name, className='', required, onChange=()=>{}, invisible, ...rest}) => {
    const methods = useFormContext();
    const validationRules = {
        required: required ? "Toto pole je povinné" : false,
      };
    return (
        <div className={className+" supercheckbox "+ (methods?.formState.errors[name]?'err':'')} style={invisible?{display:'none'}:{}}>
            <div className="supercheckbox__line">
                <input type="checkbox" name={name} id={name} onInput={(e)=>onChange(e.target.checked)} {...methods && methods.register(name, validationRules)} {...rest}  />
                <label htmlFor={name}>{children||rest?.label} {required&& <sup>*</sup>}</label>
            </div>
        </div>
    )
}

export default Checkbox;